import React from "react";
import { Container } from "react-bootstrap";
import UiButton from "../../ui/UiButton";
import { UI_BUTTON_TYPE } from "../../ui/UiButton";
import { useAuth } from "../../Auth/useAuth";
import { types } from "../../Auth/reducer";
import { useDispatch } from "react-redux";
import { main } from "../../../routes/main";
import { navigate } from "../../../routes";
import "./operatorHeader.css";
import { abortAll } from "../../../requestRegistry";

function OperatorHeader() {
  const [{ user }, { isRoleOperator }] = useAuth();
  const dispatch = useDispatch();

  const clientName = user?.client_profile?.name || user?.data?.name;

  function onClick(e) {
    abortAll();
    dispatch({
      type: types.REMOVE_CLIENT_PROFILE,
    });
    dispatch({
      type: types.DELETE_LOYALTY_REWARD,
    });
    navigate.push(main.HOME);
  }

  if (isRoleOperator() && user?.client_profile) {
    return (
      <React.Fragment>
        <Container fluid className="operator-header">
          <div className="operator-header__container">
            <div className="operator-header__text">
              Action en cours pour :
              <span className="operator-header__client-name">{" "}{clientName}</span>
            </div>
            <UiButton
              buttonUiType={[UI_BUTTON_TYPE.BLACK_BORDER]}
              onClick={onClick}
              content="Revenir à mon compte"
              size="sm"
            />
          </div>
        </Container>
      </React.Fragment>
    );
  } else {
    return <React.Fragment></React.Fragment>;
  }
}

export default OperatorHeader;
